import { string } from "prop-types";

const propTypes = {
  title: string.isRequired,
  width: string.isRequired,
  height: string.isRequired,
};

const FlagPlainIcon = (props) => {
  const { title, ...svgProps } = props;

  return (
    <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <title>{title}</title>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M6 3h2v20H6zM20 3L8 11V3z" />
        <path d="M20 11L8 3v8z" />
      </g>
    </svg>
  );
};

FlagPlainIcon.propTypes = propTypes;
export default FlagPlainIcon;
